// Raw text version for DB storage
export const POLICY_TEXT = `
GrowYourFoodApp Supplier Participation Agreement
Version: 2026-04
Effective Date: April 5, 2026

By participating as a Supplier on the GrowYourFoodApp platform, you agree to the following terms.
This Agreement outlines your responsibilities, service expectations, and the standards required
to maintain a reliable, transparent, and trustworthy experience for gardeners.

1. Accuracy of Listings
You agree to provide accurate information about:
- Product availability
- Pricing
- Varieties, and sizes
- Delivery pricing if applicable

2. Fulfillment Responsibilities
- Maintain accurate availability
      You must keep your availability up to date. If an item becomes unavailable,
      you must update it in the system immediately to prevent new orders for
      out?of?stock varieties.  GrowYourFoodApp may assist with periodic availability
      updates based on information you provide, but this does not replace your
      responsibility to maintain accurate availability at all times.

- Fulfill all prepaid orders within 14 days
      You must supply each prepaid starter within 14 calendar days of the
      gardener's payment. If the original variety cannot be supplied, you
      must provide a reasonable substitution within the same 14?day window.
      The Jeopardy Report in GrowYourFoodApp identifies items approaching
      or exceeding this limit and must be reviewed regularly.

- Ensure product quality matches the description provided
- Maintain safe and clean handling practices

3. Communication Standards
- Notify GrowYourFoodApp of operational disruptions
- Maintain professional and respectful communication at all times

4. Payment and Payouts
- Payouts are processed through Stripe Connect
- You must complete Stripe onboarding to receive funds
- You are responsible for accurate payout information
- GrowYourFoodApp does not control Stripe's processing timelines or verification requirements

5. Compliance and Conduct
- Follow all applicable local, provincial, and federal laws
- Provide products that are safe, legal, and compliant with regulations
- Avoid misleading claims or misrepresentation
- Operate with honesty and integrity

6. Platform Integrity
- Do not circumvent the platform for off-platform transactions
- Do not manipulate reviews or gardener feedback
- Do not engage in abusive, fraudulent, or harmful behavior

7. Data and Privacy
- Use gardener information only for fulfilling orders
- Do not store, sell, or reuse gardener data for any other purpose

8. Policy Updates
GrowYourFoodApp may update this Agreement in the future. If updates are made, you may be required
to review and accept the new version before continuing to use the platform.

9. Termination
GrowYourFoodApp reserves the right to suspend or remove suppliers who fail to meet standards,
violate this Agreement, or create risk or harm to customers or the platform.

By clicking "I Agree", you confirm that you have read and understood this Agreement, agree to
follow all requirements listed above, and understand that failure to comply may result in removal
from the platform.
`;

// JSX version for display
const SupplierPolicy = () => (
    <div className="instructions">
        <h2>GrowYourFoodApp Supplier Participation Agreement</h2>

        <div className="policy-section">
            <p><strong>Version:</strong> 2026-04</p>
            <p><strong>Effective Date:</strong> April 5, 2026</p>
        </div>

        <ul>
            <p>
                By participating as a Supplier on the GrowYourFoodApp platform, you agree to the following terms.
                This Agreement outlines your responsibilities, service expectations, and the standards required
                to maintain a reliable, transparent, and trustworthy experience for gardeners.
            </p>

            <h3>1. Accuracy of Listings</h3>
            <p>You agree to provide accurate information about:</p>
            <li>Product availability</li>
            <li>Pricing</li>
            <li>Varieties, and sizes</li>
            <li>Delivery pricing if applicable</li>

            <h3>2. Fulfillment Responsibilities</h3>

            <li>Maintain accurate availability</li>
            <p>
                You must keep your availability up to date. If an item becomes unavailable,
                you must update it in the system immediately to prevent new orders for
                out?of?stock varieties.  GrowYourFoodApp may assist with periodic availability
                updates based on information you provide, but this does not replace your
                responsibility to maintain accurate availability at all times.
            </p>

            <li>Fulfill all prepaid orders within 14 days</li>
            <p>
                You must supply each prepaid starter within 14 calendar days of the gardener's
                payment. If the original variety cannot be supplied, you must provide a
                reasonable substitution within the same 14?day window. The Jeopardy Report
                identifies items approaching or exceeding this limit and must be reviewed
                regularly.
            </p>

            <li>Ensure product quality matches the description provided</li>
            <li>Maintain safe and clean handling practices</li>

            <h3>3. Communication Standards</h3>
            <li>Notify GrowYourFoodApp of operational disruptions</li>
            <li>Maintain professional and respectful communication at all times</li>

            <h3>4. Payment and Payouts</h3>
            <li>Payouts are processed through Stripe Connect</li>
            <li>You must complete Stripe onboarding to receive funds</li>
            <li>You are responsible for accurate payout information</li>
            <li>GrowYourFoodApp does not control Stripe's processing timelines or verification requirements</li>

            <h3>5. Compliance and Conduct</h3>
            <li>Follow all applicable local, provincial, and federal laws</li>
            <li>Provide products that are safe, legal, and compliant with regulations</li>
            <li>Avoid misleading claims or misrepresentation</li>
            <li>Operate with honesty and integrity</li>

            <h3>6. Platform Integrity</h3>
            <li>Do not circumvent the platform for off-platform transactions</li>
            <li>Do not manipulate reviews or gardener feedback</li>
            <li>Do not engage in abusive, fraudulent, or harmful behavior</li>

            <h3>7. Data and Privacy</h3>
            <li>Use gardener information only for fulfilling orders</li>
            <li>Do not store, sell, or reuse gardener data for any other purpose</li>

            <h3>8. Policy Updates</h3>
            <p>
                GrowYourFoodApp may update this Agreement in the future. If updates are made, you may be required
                to review and accept the new version before continuing to use the platform.
            </p>

            <h3>9. Termination</h3>
            <p>
                GrowYourFoodApp reserves the right to suspend or remove suppliers who fail to meet standards,
                violate this Agreement, or create risk or harm to customers or the platform.
            </p>

            <h3>Agreement</h3>
            <p>
                By clicking "I Agree", you confirm that you have read and understood this Agreement, agree to
                follow all requirements listed above, and understand that failure to comply may result in removal
                from the platform.
            </p>
        </ul>
    </div>
);

export default SupplierPolicy;
